const getters = {
  brand: state => state.brand,
  brandInfo: state => state.brand.info,
  searchKeyWord: state => state.brand.searchKeyWord,
  urlInfo: state => state.brand.urlInfo,
  permissionInfo: state => state.brand.permissionInfo,
  webInfo: state => state.brand.webInfo,
  brandImage: state => state.brand.brandImage,
  brandImageCheckKey: state => (key) => {
    if (state.brand.brandImage[key] === undefined) return false
    else return true
  },
  brandCode: state => state.brand.info.code,
  game: state => state.game,
  gameCategory: state => state.game.gameCategory,
  gameProvider: state => state.game.gameProvider,
  goldInfo: state => state.user.goldInfo,
  mainTotal: state => (state.user.goldTotal !== undefined && state.user.goldTotal !== null) ? state.user.goldTotal : 0,
  gold: state => (state.user.goldInfo !== undefined && state.user.goldInfo !== null) ? state.user.goldInfo.gold : 0,
  commonGold: state => (state.user.goldInfo !== undefined && state.user.goldInfo !== null) ? state.user.goldInfo.common_gold : 0,
  commissionGold: state => (state.user.commissionGold !== undefined && state.user.commissionGold !== null) ? state.user.commissionGold : 0,
  mainGold: state => (state.user.mainGold !== undefined && state.user.mainGold !== null) ? state.user.mainGold : 0,
  bonusGold: state => (state.user.bonusGold !== undefined && state.user.bonusGold !== null) ? state.user.bonusGold : 0,
  mainPoint: state => (state.user.mainPoint !== undefined && state.user.mainPoint !== null) ? state.user.mainPoint : 0,
  mainTurnover: state => (state.user.mainTurnover !== undefined && state.user.mainTurnover !== null) ? state.user.mainTurnover : 0,
  point: state => state.user.point,
  gameBalance: state => state.user.gameBalanceInfo,
  name: state => state.user.memberInfo ? state.user.memberInfo.nickname : 'Guest',
  user: state => state.user,
  language: state => state.user.language,
  supportLanguages: state => state.user.supportLanguages,
  deviceInfo: state => state.user.deviceInfo,
  memberInfo: state => state.user.memberInfo,
  token: state => state.user.token,
  app: state => state.app,
  isLoading: state => state.app.isLoading,
  inGameId: state => state.app.inGameId,
  leaveGamePath: state => state.app.leaveGamePath,
  inviteCode: state => state.user.inviteCode,
  shareCode: state => state.user.shareCode,
  couponCode: state => state.user.couponCode,
  btag: state => state.user.btag,
  group: state => state.user.group,
  loadCompleted: state => state.app.loadCompleted,
  noticeMessage: state => state.app.noticeMessage,
  requestMessage: state => state.app.requestMessage,
  adMessage: state => state.app.adMessage,
  isApiExecute: state => state.app.isApiExecute,
  toastMessage: state => state.app.toastMessage,
  errorMessage: state => state.app.errorMessage,
  readTerms: state => state.brand.readTerms,
  readAnnouncement: state => state.brand.readAnnouncement,
  supportPhoneCode: state => state.brand.supportPhoneCode,
  showGameWalletModal: state => state.app.showGameWalletModal,
  currentTheme: state => state.brand.theme,
  showSearch: state => state.brand.showSearch,
  gameIdsArray: state => state.app.gameIdsArray,
  walletInfo: state => state.user.walletInfo,
  agreeCookie: (state) => {
    // Check if the preference is stored in a cookie
    const isAgreeCookie = document.cookie.split('; ').find((item) => item.startsWith('isAgreeCookie='))
    if (isAgreeCookie) {
      return isAgreeCookie.split('=')[1] === 'true'
    } else {
      state.app.isAgreeCookie = false
    }
    // Use the value from the Vuex state
    return state.app.isAgreeCookie
  }
}
export default getters
